// store.js
import Vue from 'vue';
import Vuex from 'vuex';
import inquiryWizard from './modules/inquiryWizard';
import SurveyRevisionMixin from '@/mixins/SurveyRevisionMixin';

const state = {
  ui: {
    markets: {
      items: [],
      firstLoad: true,
      menuCollapsed: false
    },
    retailers: {
      items: [],
      firstLoad: true,
      menuCollapsed: false
    },
    firstLoad: true,
    columnBackup: null
  },

  headerFilter: {}
};

Vue.use(Vuex);

export default new Vuex.Store({
  namespaced: true,
  state: state,
  modules: {
    ...(SurveyRevisionMixin.computed.isInquiryWizardEnabled() ? { inquiryWizard } : {}),
  },
  getters: {},
  mutations: {
    markets(state, value) {
      state.ui.markets.items = value;
      if (value.length > 0)
        state.ui.markets.firstLoad = false;
    },

    ColumnBackup(state, value) {
      state.ui.columnBackup = value;
      if (value.length > 0)
        state.ui.firstLoad = false;
    },

    marketsMenuCollapsed(state, value) {
      state.ui.markets.menuCollapsed = value;
    },

    retailers(state, value) {
      state.ui.retailers.items = value;
      if (value.length > 0)
        state.ui.retailers.firstLoad = false;
    },

    retailersMenuCollapsed(state, value) {
      state.ui.retailers.menuCollapsed = value;
    },

    headerFilter(state, value) {
      state.headerFilter = { ...value };
    }
  },
  actions: {}
});
